import React, { useState, useEffect, useCallback, useRef } from "react";
import { useListFilters } from "../../helper/useListFilters";
import useRealtimeSync from "../../hooks/useRealtimeSync";
import { lastQuery } from "../../helper/lastQuery";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  CircularProgress,
  FormGroup,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Switch,
  TextField,
  Tooltip,
  Typography,
  createSvgIcon,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import OutlinedTextAreaField from "../../component/inputfiled/OutlinedTextedArea";
import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import MyDatePicker from "../../component/datepicker/OutlinedDatepicker";
import dayjs from "dayjs";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Calendar from "../../Icon/Calendar";
import CustomButton from "../../component/button/button";
import Previews from "../../component/dropzone/Mydropzone";
import MyLogoDropzone from "../../component/dropzone/LogoDropzone";
import CustomOutlinedSelect from "../../component/select field/OutlinedSelectField";
import CustomDataTable from "../../component/datatable/DataTable";
import Mylogodropzone from "../../component/dropzone/Mylogodropzone";
import CustomSelect from "../../component/select field/OutlinedSelectField";
import Setting from "../../Icon/Setting";
import OutlineCustomButton from "../../component/button/outlineButton";
import Settinglist from "../../Icon/Settinglist";
import { useDispatch, useSelector } from "react-redux";

import {
  GetContractTypeAction,
  GetCountryAction,
  GetUniversityAction,
} from "../../Redux/action/SettingAction.js";
import Msg from "../../Icon/Msg";
import Message from "../../Icon/Message";
import SnackbarComponent from "../../component/snackbar/snackbar";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useNavigate } from "react-router-dom";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ConfirmationModal from "../../component/Modal/ConfirmationModal/ConfirmationModal";
import DeleteWithDependencyModal from "../../component/Modal/DeleteWithDependencyModal";
import {
  DeleteUniversityService,
  EditUnivBlockedStatusService,
} from "../../Redux/service/SettingService";
import { handleExport } from "../ExportFunction/ExportFunction";
import FilterComponent from "../../component/filterForTable/FilterComponent";
import { basicurl, token } from "../../Redux/ServiceUrl/url";
import axios from "axios";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ListIcon from "@mui/icons-material/List";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DescriptionIcon from "@mui/icons-material/Description";
import { CustomPagination } from "../../component/datatable/CustomPagination";
import { BulkUploadModal } from "../../component/Modal/BulkUploadModal";
import { DownloadUniBulkUploadTemplateModal } from "../../component/Modal/DownloadBulkUploadUniv";
import { toTitleCase } from "../../helper/helper";
import GlobalSearch from "../../component/sidebar/globalSearch";

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const selectOptions = [
  { value: 10, label: "Option 1" },
  { value: 20, label: "Option 2" },
  { value: 30, label: "Option 3" },
];
const UniversitylistPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [BulkModal, setBulkModal] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openbulk = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleBulkClose = () => {
    setAnchorEl(null);
  };

  const [Universitylist, setUniversitylist] = useState([]);
  const [UniversitylistStateData, setUniversitylistStateData] = useState([]);

  const [table_load, setTable_load] = useState(false);

  const [isToggled, setIsToggled] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [confirmationopen, setConfirmationOpen] = useState(false);
  const [changeBlockStatusOfOrg, setChangeBlockStatusOfOrg] = useState({});
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [Countrylist, setCountrylist] = useState([]);
  const [contractTypelist, setContractTypelist] = useState([]);
  const [uploadTemplateModal, setUploadTemplateModal] = useState(false);

  const [data, setData] = useState([]);

  const [visibleColumns, setVisibleColumns] = useState([]);

  const [loading, setLoading] = useState(true);

  const [paginationModel, setPaginationModel] = useState({
    page: 1,
    pageSize: 2,
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 50,
    hasNextPage: false,
    hasPrevPage: false,
  });

  // University queued for deletion: { id, name } or null.
  // Declared before `columns` because the action cell references the setter.
  const [universityToDelete, setUniversityToDelete] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Hide the loader after 2 seconds
    }, 2000); // Simulate 2 seconds of loading time
  }, []);

  const handleVisibleColumnsChange = (columns) => {
    console.log("Visible Columns in Parent:", columns);
    setVisibleColumns(columns);
  };

  const columns = [
    ...// window.sessionStorage.getItem("user_role_type") === "agent" &&
    // window.sessionStorage.getItem("role") !== "admin"
    (window.sessionStorage.getItem("user_role_type") === "admin"
      ? [
        {
          field: "action",
          headerName: "Action",
          width: 200,
          renderCell: (params) => {
            const handleEditActionClick = (event) => {
              event.stopPropagation();

              navigate(`/CAE/EditUniversity/${params.row.id}`);
            };
            const handleAddProgramClick = (event) => {
              event.stopPropagation();
              navigate(`/CAE/AddProgram/${params.row.id}`);
            };
            const handleListProgramClick = (event) => {
              event.stopPropagation();
              navigate(`/CAE/ProgramList/${params.row.id}`);
            };
            const handleListProccessClick = (event) => {
              event.stopPropagation();
              navigate(`/CAE/ProcessList\/${params.row.id}`);
            };
            return (
              <>
                {" "}
                {!window.sessionStorage.getItem("user_role_type") ===
                  "agent" &&
                  (window.sessionStorage.getItem("user_role_type") ===
                    "agent" ||
                    window.sessionStorage.getItem("role") === "admin") ? (
                  <Tooltip title="View University">
                    {" "}
                    <IconButton onClick={handleEditActionClick}>
                      <RemoveRedEyeIcon
                        sx={{ fill: ThemeColor.LIGHTPURPLE }}
                      />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <div>
                    <Tooltip title="Edit University">
                      {" "}
                      <IconButton onClick={handleEditActionClick}>
                        <ModeEditIcon sx={{ fill: ThemeColor.LIGHTPURPLE }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Add Program">
                      {" "}
                      <IconButton onClick={handleAddProgramClick}>
                        <AddCircleIcon
                          sx={{ fill: ThemeColor.LIGHTPURPLE }}
                        />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="List Program">
                      {" "}
                      <IconButton onClick={handleListProgramClick}>
                        <ListIcon sx={{ fill: ThemeColor.LIGHTPURPLE }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Process Sheet">
                      {" "}
                      <IconButton onClick={handleListProccessClick}>
                        <DescriptionIcon
                          sx={{ fill: ThemeColor.LIGHTPURPLE }}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
              </>
            );
          },
        },
      ]
      : []),

    {
      field: "name",
      headerName: "University Name",
      flex: 1,
      minWidth: 220,
      renderCell: (params) => {
        const handleEditActionClick = (event) => {
          event.stopPropagation();
          navigate(`/CAE/University-overview/${params.row.id}`);
        };
        return (
          <div
            style={{ textDecoration: "underline" }}
            onClick={handleEditActionClick}
          >
            {toTitleCase(params.row.name)}
          </div>
        );
      },
    },

    {
      field: "state",
      headerName: "State",
      width: 150,
      renderCell: (params) => {
        return <div className="d-flex">{toTitleCase(params.row.state)}</div>;
      },
    },
    {
      field: "city",
      headerName: "City",
      width: 150,
      renderCell: (params) => {
        return <div className="d-flex">{toTitleCase(params.row.city)}</div>;
      },
    },
    {
      field: "country",
      headerName: "Country",
      width: 100,
      renderCell: (params) => {
        return <div className="d-flex">{toTitleCase(params.row.country)}</div>;
      },
    },
    {
      field: "ContarctType",
      headerName: "Contract Type",
      width: 150,
      renderCell: (params) => {
        return <div>{toTitleCase(params.row.contractType?.contractType)}</div>;
      },
    },
    {
      field: "contractExpireDate",
      headerName: "Contract Validity ",
      width: 150,
      renderCell: (params) => {
        return (
          <div>
            {params.row?.contractExpireDate
              ? dayjs(params.row.contractExpireDate).format("YYYY-MM-DD HH:MM")
              : "-"}
          </div>
        );
      },
    },

    // {
    //   field: "isActive",
    //   headerName: "Status",
    //   width: 200,
    //   renderCell: (params) => {
    //     return (
    //       <div className="d-flex">
    //         {params.row?.isActive === "Y" ? "Active" : "In-active"}
    //       </div>
    //     );
    //   },
    // },

    {
      field: "isBlocked",
      headerName: "",
      width: 150,
      renderCell: (params) => {
        const handleBlockingActionClick = (event) => {
          event.stopPropagation();
          const newBlockedValue = params.row.isBlocked === "Y" ? "N" : "Y";
          // optimistic update
          setUniversitylist((prev) =>
            prev.map((data) =>
              data.id === params.row.id ? { ...data, isBlocked: newBlockedValue } : data
            )
          );
          setChangeBlockStatusOfOrg({ id: params.row.id, isBlocked: newBlockedValue });
          setConfirmationOpen(true);
        };

        // show button only for admin
        if (window.sessionStorage.getItem("user_role_type") !== "admin") return null;

        const isBlocked = params.row.isBlocked === "Y";
        return (
          <Box display="flex" alignItems="center" className="px-2">
            <Button
              size="small"
              variant="contained"
              onClick={handleBlockingActionClick}
              sx={{
                backgroundColor: isBlocked ? "#28a745" : ThemeColor.RED,
                color: ThemeColor.WHITE,
                textTransform: "none",
                minWidth: 90,
                '&:hover': {
                  backgroundColor: isBlocked ? '#229a3f' : '#c92b27',
                },
              }}
            >
              {isBlocked ? "Unblock" : "Block"}
            </Button>
          </Box>
        );
      },
    },
    // Delete sits last, after the Block button.
    {
      field: "delete",
      headerName: "",
      width: 80,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        if (window.sessionStorage.getItem("user_role_type") !== "admin") {
          return null;
        }

        const handleDeleteActionClick = (event) => {
          event.stopPropagation();
          setUniversityToDelete({
            id: params.row.id,
            name: params.row.name,
          });
        };

        return (
          <Tooltip title="Delete University">
            <IconButton onClick={handleDeleteActionClick}>
              <DeleteOutlineIcon sx={{ fill: ThemeColor.RED }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    // {
    //   field: "action",
    //   headerName: "",
    //   width: 150,
    //   renderCell: (params) => {
    //     const handleActionClick = (event) => {
    //       event.stopPropagation(); // Prevent the row from being selected when clicking the icon
    //       dispatch(showSnackbar("This is a success message!", "success"));
    //       // //("Edit clicked for ID:", params.row.id);
    //     };
    //     return (
    //       <div>
    //         <IconButton onClick={handleActionClick}>
    //           <Message />
    //         </IconButton>
    //       </div>
    //     );
    //   },
    // },
  ];

  const CountrylistState = useSelector(
    (state) => state.setting?.countryCount?.data?.data
  );

  const UniversitylistState = useSelector(
    (state) => state.setting?.university?.data
  );

  const ContractTypeListState = useSelector(
    (state) => state.setting?.contractType?.data?.data
  );

  const [limit, setLimit] = useState(50);

  const handleLimitChange = (newLimit) => {
    setTable_load(true);
    setLimit(newLimit);

    reload({ page: 1, limit: newLimit });
  };

  const handlePageChange = (page) => {
    setTable_load(true);
    console.log(page);
    let data = {
      page: page,
      limit: limit,
    };
    reload(data);
    // fetchData(page, pagination.limit);
  };

  useEffect(() => {
    // console.log(CountrylistState)
    setCountrylist(
      CountrylistState?.map(({ country, ...rest }) => ({
        title: country,
        _id: country,
        ...rest,
      }))
    );
  }, [CountrylistState]);

  useEffect(() => {
    dispatch({ type: "GetUniversityList", payload: null });
    setTable_load(true);
    dispatch(GetCountryAction());
    let data = {
      page: 1,
      limit: 50,
    };

    reload(data);
  }, []);

  // Someone else (or another screen) added, updated or deleted a university:
  // reload exactly the view the user is looking at. Local edits go through the
  // same path, so the table is never stale.
  useRealtimeSync(
    "university",
    useCallback(() => {
      setTable_load(true);
      reload(lastQuery("university", { page: 1, limit: 50 }));
    }, [dispatch])
  );

  useEffect(() => {
    // Rows for a filtered view do not come from redux. Letting this run
    // would write the stale unfiltered list back over them - which is why
    // the filter survived a reload (redux is empty then) but not a Back.
    //
    // A later redux change means an action elsewhere refreshed the data
    // (a modal, an import), so the filtered view is fetched again instead.
    if (getFilters().length > 0) {
      if (reduxSyncedOnce.current) fetchData(getFilters());
      reduxSyncedOnce.current = true;
      return;
    }
    reduxSyncedOnce.current = true;
    if (!isToggled) {
      setUniversitylistStateData(UniversitylistState?.universities);
      setUniversitylist(
        UniversitylistState?.universities?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    } else {
      setUniversitylistStateData(UniversitylistState?.blockedUniversity);

      setUniversitylist(
        UniversitylistState?.blockedUniversity?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    }
    if (UniversitylistState != undefined) setTable_load(false);
  }, [UniversitylistState]);

  useEffect(() => {
    console.log(UniversitylistState?.pagination);
    if (UniversitylistState) {
      // const { data, pagination } = UniversitylistState;
      // setRows(data);
      setPagination(UniversitylistState?.pagination);
    }
  }, [UniversitylistState]);
  // Handle toggle change
  const handleStatusChange = async () => {
    const newToggleState = !isToggled;
    if (newToggleState) {
      setUniversitylist(
        UniversitylistState?.blockedUniversity?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    } else {
      setUniversitylist(
        UniversitylistState?.universities?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    }
    setIsToggled(newToggleState);
  };

  useEffect(() => {
    dispatch(GetContractTypeAction());
  }, []);
  useEffect(() => {
    const updatedData = ContractTypeListState?.map(
      ({ contractType, ...rest }) => ({
        title: contractType,
        ...rest,
      })
    );
    setContractTypelist(updatedData);
  }, [ContractTypeListState]);

  const fields = [
    // { label: "Agent ID", value: "agentId", type: "select", option: Agentlist },
    {
      label: "University Name",
      value: "name",
      type: "text",
      // option: UniversitylistStateData?.map(({ name, ...rest }) => ({
      //   title: name,
      //   ...rest,
      // })),
    },
    {
      label: "Country Name",
      value: "country",
      type: "multi-select",
      option: Countrylist?.map(({ country, ...rest }) => ({
        title: country,
        _id: country,
        ...rest,
      })),
    },
    {
      label: "State Name",
      value: "state",
      type: "text",
      // option: UniversitylistStateData?.map(({ name, ...rest }) => ({
      //   title: name,
      //   ...rest,
      // })),
    },
    {
      label: "City Name",
      value: "city",
      type: "text",
      // option: UniversitylistStateData?.map(({ name, ...rest }) => ({
      //   title: name,
      //   ...rest,
      // })),
    },
    {
      label: "Contract Validity(YYYY)",
      value: "contractValidity",
      type: "text",
      // option: UniversitylistStateData?.map(({ name, ...rest }) => ({
      //   title: name,
      //   ...rest,
      // })),
    },
    {
      label: "Contract Type",
      value: "contractType",
      type: "multi-select",
      option: contractTypelist,
    },
    // {
    //   label: "Is Active",
    //   value: "isActive",
    //   type: "select",
    //   option: [
    //     { _id: "Y", title: "Yes" },
    //     { _id: "N", title: "No" },
    //   ],
    // },
  ];

  const fetchData = async (filters) => {
    let string = filters.map((data) => `${data.field}=${data.value}`);
    try {
      let response = await axios.get(
        basicurl +
        `/api/university/get-all-university?${string.join(
          "&"
        )}&limit=${0}&page=${1}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // const result = await response.json();
      // console.log(response);
      setPagination(response?.data?.pagination);
      if (isToggled) {
        setUniversitylist(
          response?.data?.blockedUniversity?.map(({ _id, ...rest }) => ({
            id: _id,
            ...rest,
          }))
        );
      } else {
        setUniversitylist(
          response?.data?.universities?.map(({ _id, ...rest }) => ({
            id: _id,
            ...rest,
          }))
        );
      }
      // setData(
      //   response.data.students?.map(({ _id, ...rest }) => ({
      //     id: _id,
      //     ...rest,
      //   }))
      // ); // Assuming the response structure has a `data` key
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  /**
   * Reload the rows.
   *
   * Every action on this page reloads through here so that a filter which
   * is on screen stays applied. Applying a filter used `fetchData` while
   * every action afterwards used the plain redux action, so the table went
   * back to showing everything while the panel still said a filter was on.
   *
   * The filters live in component state, so leaving the page and coming
   * back starts clean with the full list.
   */
  /** False until the first redux sync, so mounting does not fetch twice. */
  const reduxSyncedOnce = useRef(false);

  const { activeFilters, getFilters, applyFilters } = useListFilters(
    (filters) => fetchData(filters),
    () => dispatch(GetUniversityAction({ page: 1, limit: limit }))
  );

  const reload = (data) => {
    // Read through the ref: some of the callers below are memoised with
    // empty deps, so a captured value would be frozen as "no filters".
    const applied = getFilters();
    if (applied.length > 0) {
      fetchData(applied);
      return;
    }
    dispatch(GetUniversityAction(data));
  };

  const handleApplyFilters = applyFilters;

  const handleGetBulkTemplate = async () => {
    try {
      const response = await axios.get(
        `${basicurl}/api/university/download-university-template`,
        {
          responseType: "blob", // 👈 VERY important for binary data like Excel
        }
      );

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a download link and click it
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "university_bulk.xlsx"; // 👈 you can set a dynamic filename
      document.body.appendChild(a);
      a.click();
      a.remove();

      // Clean up the blob URL
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontSize: "24px",
            color: "#007bff",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "transparent",
            }}
          >
            <div style={{ width: "100%", height: "100%", justifyContent: "center", display: "flex", alignItems: "center" }}>
              <img
                src="/assest/Group.png" // Your image URL
                alt="Loading..."
                style={{ width: "75%", height: "75%", objectFit: "contain" }}
              />
            </div>

            <CircularProgress
              size={100}
              sx={{
                color: ThemeColor.NAVYBLUE, // Customize the loader color
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
              }}
            />
          </div>
        </div>
      ) : (
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid item lg={3} md={3} xs={12}>
              <div className="d-flex align-items-center">
                <IconButton onClick={() => navigate(-1)}>
                  <ArrowBackIcon />
                </IconButton>

                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h2.small}
                >
                  University List
                </Typography>
              </div>
            </Grid>
            <Grid item lg={9} md={9} xs={12}>
              <Box
                className="d-flex align-items-center w-100"
                sx={{
                  justifyContent: {
                    xs: "flex-start",
                    sm: "flex-start",
                    md: "flex-end",
                  },
                  flexWrap: "wrap",
                  gap: 1.5,
                }}
              >
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() => setFilterOpen(true)}
                >
                  Filter
                </OutlineCustomButton>
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() =>
                    handleExport(
                      selectionModel,
                      "University",
                      Universitylist,
                      "isActive",
                      visibleColumns
                    )
                  }
                >
                  Export
                </OutlineCustomButton>

                {(!window.sessionStorage.getItem("user_role_type") === "agent" ||
                  window.sessionStorage.getItem("user_role_type") === "admin" ||
                  window.sessionStorage.getItem("user_role_type") === "user") && (
                  <Box
                    display="flex"
                    sx={{
                      border: `2px solid ${ThemeColor.GREY}`,
                      borderRadius: 25,
                      px: 2,
                      py: 0.5,
                    }}
                    alignItems="center"
                  >
                    <Typography>Blocked</Typography>
                    <Switch
                      sx={{
                        "& .MuiSwitch-track": {
                          transition: "background-color 0.3s",
                          borderRadius: 20,
                        },
                        "& .MuiSwitch-thumb": {
                          width: 24,
                          height: 24,
                          backgroundColor: isToggled
                            ? ThemeColor.PURPLE
                            : ThemeColor.BLACK,
                          transition: "transform 0.3s ease",
                          transform: isToggled
                            ? "translateX(2px)"
                            : "translateX(0px)",
                        },
                        "& .MuiSwitch-switchBase": {
                          padding: 1,
                          transition: "transform 0.3s",
                          "&.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: ThemeColor.LIGHTPURPLE,
                          },
                        },
                      }}
                      checked={isToggled ? true : false}
                      onChange={handleStatusChange}
                      color="primary"
                    />
                  </Box>
                )}

                {(!window.sessionStorage.getItem("user_role_type") === "agent" ||
                  window.sessionStorage.getItem("user_role_type") === "admin" ||
                  window.sessionStorage.getItem("user_role_type") === "user") && (
                  <>
                    <CustomButton
                      variant="contained"
                      type="submit"
                      backgroundColor={ThemeColor.YELLOW}
                      color={ThemeColor.WHITE}
                      onClick={handleClick}
                    >
                      Bulk Update
                    </CustomButton>
                    <Menu
                      id="demo-positioned-menu"
                      aria-labelledby="demo-positioned-button"
                      anchorEl={anchorEl}
                      open={openbulk}
                      onClose={handleBulkClose}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                    >
                      <MenuItem
                        onClick={() =>
                          setUploadTemplateModal(!uploadTemplateModal)
                        }
                      >
                        Download Template
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setBulkModal(!BulkModal);
                        }}
                      >
                        Upload Data (Bulk)
                      </MenuItem>
                    </Menu>
                  </>
                )}
                {(!window.sessionStorage.getItem("user_role_type") === "agent" ||
                  window.sessionStorage.getItem("user_role_type") === "admin" ||
                  !window.sessionStorage.getItem("user_role_type") === "user") && (
                  <CustomButton
                    variant="contained"
                    type="submit"
                    backgroundColor={ThemeColor.PURPLE}
                    color={ThemeColor.WHITE}
                    onClick={() => navigate("/CAE/CreateUniversity")}
                  >
                    Add University
                  </CustomButton>
                )}
              </Box>
            </Grid>
          </Grid>
          <div className="table-container" style={{ overflowX: "hidden" }}>
            <CustomDataTable
              row={Universitylist ? Universitylist : []}
              columns={columns}
              loading={table_load}
              onSelectionChange={(newSelection) => {
                setSelectionModel(newSelection);
              }}
              getRowClassName={(params) =>
                params.row.isActive === "Y" ? "row-white" : "row-dull"
              }
              onVisibleColumnsChange={handleVisibleColumnsChange}
              minTableWidth="100%"
            />
          </div>

          <BulkUploadModal
            open={BulkModal}
            handleClose={() => {
              setBulkModal(!BulkModal);
            }}
            url={"api/university/bulk-upload-universities"}
            action={() => {
              let data = {
                limit: limit,
                page: 1,
              };
              reload(data);
            }}
          />
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            limit={limit}
            onLimitChange={handleLimitChange}
          />
          <FilterComponent
            open={isFilterOpen}
            onClose={() => setFilterOpen(false)}
            onApply={handleApplyFilters}
            initialFilters={activeFilters}
            fields={fields}
          />
          <ConfirmationModal
            msg="Updated"
            btnName="Update"
            handleConfirmationClose={() => {
              setUniversitylist((prev) =>
                prev.map((data) =>
                  data.id === changeBlockStatusOfOrg.id
                    ? {
                      ...data,
                      isBlocked:
                        changeBlockStatusOfOrg.isBlocked === "Y" ? "N" : "Y",
                    }
                    : data
                )
              );
              setConfirmationOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await EditUnivBlockedStatusService(
                  changeBlockStatusOfOrg
                );

                if (res.status === 200) {
                  // let data = {
                  //   page: 1,
                  //   limit: 2,
                  // };
                  let data = {
                    page: 1,
                    limit: limit,
                  };
                  reload(data);
                  // setIsToggled(!isToggled); // Dispatch the action if success
                  return res; // Return the result so the child can access it
                } else {
                  return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={confirmationopen}
            message={
              changeBlockStatusOfOrg?.isBlocked === "Y"
                ? "Do you wish to block the university?"
                : "Do you wish to unblock the university?"
            }
          />
          <DeleteWithDependencyModal
            open={Boolean(universityToDelete)}
            onClose={() => setUniversityToDelete(null)}
            entityLabel="University"
            entityName={universityToDelete?.name || ""}
            cascadeItems={[
              "Its folder, sub-folders and every file inside them",
              "Its contract documents and reminders",
            ]}
            onDelete={() => DeleteUniversityService(universityToDelete.id)}
            onDeleted={() => {
              dispatch(showSnackbar("University deleted", "success"));
              reload({ page: 1, limit: limit });
            }}
          />

          <DownloadUniBulkUploadTemplateModal
            open={uploadTemplateModal}
            handleClose={() => {
              setUploadTemplateModal(!uploadTemplateModal);
            }}
          />
        </>
      )}
    </div>
  );
};

function Universitylist() {
  const dispatch = useDispatch();

  const handleSearch = (searchValue) => {
    console.log(searchValue)
    let data = {
      page: 1,
      limit: 50,
      search: searchValue
    };

    dispatch(GetUniversityAction(data));
  };
  return (
    <div>
      <ResponsiveDrawer
        maincontent={<UniversitylistPage />}
        globalsearch={<GlobalSearch onSearch={handleSearch} />}
      />
    </div>
  );
}

export default Universitylist;
